import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';

// =========================
// COMPONENTE FOTO (SUB-RECURSO)
// =========================
const FotoItem = ({ idItem, tipoFoto, titulo, onZoom, isEditable, onFileSelect }) => {
   const [foto, setFoto] = useState(null);
   const [loading, setLoading] = useState(true);
   const fileInputRef = useRef(null);

   useEffect(() => {
      const carregarFoto = async () => {
         try {
            const res = await api.get(`/vistoria/foto/${idItem}`);
            if (res.data && res.data.length > 0) {
               const dados = res.data[0];
               setFoto(tipoFoto === 'antes' ? dados.foto_antes : dados.foto_depois);
            }
         } catch (e) {
            console.error("Erro ao carregar foto:", e);
         } finally {
            loading && setLoading(false);
         }
      };
      carregarFoto();
   }, [idItem, tipoFoto]);

   const handleClick = () => {
      if (isEditable && !foto) {
         fileInputRef.current.click();
      } else if (foto) {
         onZoom(`data:image/jpeg;base64,${foto}`);
      }
   };

   return (
      <div className="text-center">
         <label style={{ fontSize: '10px', fontWeight: 'bold' }} className="text-muted d-block mb-1">
            {titulo}
         </label>
         <div
            className="rounded border bg-light d-flex align-items-center justify-content-center shadow-sm"
            style={{ height: '140px', overflow: 'hidden', cursor: 'pointer', position: 'relative' }}
            onClick={handleClick}
         >
            {loading ? (
               <div className="spinner-border spinner-border-sm text-primary"></div>
            ) : foto ? (
               <img src={`data:image/jpeg;base64,${foto}`} className="img-fluid" style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt={titulo} />
            ) : (
               <div className="text-muted small text-center px-2">
                  <i className={`fa ${isEditable ? 'fa-camera' : 'fa-image'} d-block mb-1 opacity-50`} style={{ fontSize: '24px' }}></i>
                  {isEditable ? 'TIRAR FOTO' : 'SEM FOTO'}
               </div>
            )}
         </div>
         {isEditable && (
            <input
               type="file" accept="image/*" capture="environment"
               ref={fileInputRef} style={{ display: 'none' }}
               onChange={(e) => onFileSelect(e.target.files[0])}
            />
         )}
      </div>
   );
};

// =========================
// COMPONENTE PRINCIPAL
// =========================
const VistoriaResposta = () => {
   const { token } = useParams();
   const navigate = useNavigate();
   const [vistoria, setVistoria] = useState(null);
   const [itens, setItens] = useState([]);
   const [loading, setLoading] = useState(false);
   const [zoomImg, setZoomImg] = useState(null);

   // Decodificação robusta para UTF-8/Base64 do Oracle
   const decodeBase64 = (str) => {
      if (!str || str === "null") return "";
      try {
         return decodeURIComponent(escape(window.atob(str.trim())));
      } catch (e) {
         return str;
      }
   };

   useEffect(() => {
      if (!localStorage.getItem("chapa")) {
         navigate(`/?origem=vistoria-execucao&token=${token}`);
         return;
      }
      if (token) carregarDados();
   }, [token]);

   const carregarDados = async () => {
      setLoading(true);
      try {
         const res = await api.get(`/vistoria/token/${token}`);
         if (res.data && res.data.cabecalho) {
            setVistoria(res.data.cabecalho);

            // TRATAMENTO DOS DADOS: Decodifica descrição e observação
            const itensTratados = (res.data.itens || []).map(it => ({
               ...it,
               descricao_ponto: decodeBase64(it.descricao_ponto)
            }));

            setItens(itensTratados);
         }
      } catch (err) {
         Swal.fire('Erro', 'Falha ao carregar vistoria.', 'error');
      } finally {
         setLoading(false);
      }
   };

   const responderItem = async (item, arquivoFoto = null) => {
      // VALIDAÇÃO REFORÇADA: Bate na API para checar se a foto_antes existe no banco
      setLoading(true);
      try {
         const resFoto = await api.get(`/vistoria/foto/${item.id_item}`);
         const dadosFoto = resFoto.data && resFoto.data.length > 0 ? resFoto.data[0] : null;

         // Se existir foto_antes, E não houver foto_depois salva, E não estiver anexando arquivoFoto agora...
         if (dadosFoto && dadosFoto.foto_antes) {
            if (!dadosFoto.foto_depois && !arquivoFoto) {
               setLoading(false);
               Swal.fire({
                  title: 'Foto Obrigatória',
                  text: 'Este item possui uma foto "ANTES". Clique no quadro "SOLUÇÃO" para tirar a foto obrigatória antes de responder.',
                  icon: 'warning',
                  confirmButtonText: 'Entendido'
               });
               return; // Interrompe a execução
            }
         }
      } catch (error) {
         console.error("Erro ao validar fotos:", error);
      }
      setLoading(false);

      const { value: obs } = await Swal.fire({
         title: 'Responder Item',
         html: `<textarea id="swal-obs" class="form-control" rows="4" placeholder="Descreva a solução...">${item.obs_gerente || ''}</textarea>`,
         showCancelButton: true,
         confirmButtonText: 'Salvar Resposta',
         preConfirm: () => document.getElementById('swal-obs').value
      });

      if (obs !== undefined) {
         processarEnvio(item, obs, arquivoFoto);
      }
   };

   const processarEnvio = async (item, obs, file) => {
      setLoading(true);
      try {
         let fotoBase64 = "";
         if (file) {
            const reader = new FileReader();
            fotoBase64 = await new Promise((resolve) => {
               reader.onload = () => resolve(reader.result.split(',')[1]);
               reader.readAsDataURL(file);
            });
         }

         await api.put('/vistoria/executar', {
            id_item: item.id_item,
            id_vistoria: vistoria.id_vistoria,
            obs: obs,
            foto: fotoBase64,
            id_gerente: localStorage.getItem("chapa")
         });

         Swal.fire('Sucesso', 'Resposta salva!', 'success');
         carregarDados();
      } catch (err) {
         Swal.fire('Erro', 'Não foi possível salvar.', 'error');
         console.error(err);
      } finally {
         setLoading(false);
      }
   };

   return (
      /* WRAPPER PRINCIPAL: Trava o vazamento horizontal (Estouro de tela no Safari) */
      <div style={{ overflowX: 'hidden', width: '100%', position: 'relative', minHeight: '100vh' }}>
         <Menu modulo="ARBOR" />

         {/* Container ajustado para não gerar scroll invisível */}
         <div
            className="container-fluid px-2 px-md-3"
            style={{
               paddingTop: '85px',
               paddingBottom: '100px'
            }}
         >
            {vistoria && (
               <div
                  className="card border-0 shadow-sm mb-4"
                  style={{ borderLeft: '5px solid #0056b3' }}
               >
                  <div className="card-body py-3">
                     <h6 className="fw-bold mb-1 text-break" style={{ color: '#0056b3' }}>
                        Vistoria #{vistoria.id_vistoria}
                     </h6>
                     <small className="text-muted d-block text-break">
                        {vistoria.razao}
                     </small>
                  </div>
               </div>
            )}

            {/* A classe 'mx-0' anula as margens negativas do Bootstrap que o Safari interpreta mal */}
            <div className="row mx-0">
               {itens.map(item => (
                  <div className="col-12 mb-3 px-1" key={item.id_item}>
                     <div className="card border-0 shadow-sm">
                        <div className="card-body">
                           <div className="d-flex justify-content-between mb-2">
                              <span className="badge bg-light text-dark border small">{item.tipo}</span>
                              <span className={`small fw-bold ${item.status_item === 'EXECUTADO' ? 'text-success' : 'text-warning'}`}>
                                 {item.status_item === 'EXECUTADO' ? '● CONCLUÍDO' : '○ PENDENTE'}
                              </span>
                           </div>

                           <p className="mb-3 fw-bold text-break">
                              <div className="mb-3">
                                 {item.descricao_ponto && item.descricao_ponto.includes('[RÉPLICA]:') ? (
                                    <>
                                       {/* Remove o <b> solto do texto original */}
                                       <div>{item.descricao_ponto.split('[RÉPLICA]:')[0].replace(/<\/?b>/gi, '')}</div>

                                       {/* Remove o </b> solto do texto da Réplica e exibe na caixa vermelha */}
                                       <div className="alert alert-danger mt-2 mb-0 p-2 small fw-bold">
                                          <i className="fa fa-exclamation-triangle me-1"></i>
                                          [RÉPLICA]: {item.descricao_ponto.split('[RÉPLICA]:')[1].replace(/<\/?b>/gi, '')}
                                       </div>
                                    </>
                                 ) : (
                                    item.descricao_ponto ? item.descricao_ponto.replace(/<\/?b>/gi, '') : ''
                                 )}
                              </div>
                           </p>

                           {/* A classe 'mx-0' novamente evita que essa row estoure dentro do card */}
                           <div className="row g-2 mb-3 mx-0">
                              <div className="col-6 px-1">
                                 <FotoItem idItem={item.id_item} tipoFoto="antes" titulo="ANTES" onZoom={setZoomImg} />
                              </div>
                              <div className="col-6 px-1">
                                 <FotoItem
                                    idItem={item.id_item} tipoFoto="depois" titulo="SOLUÇÃO"
                                    onZoom={setZoomImg} isEditable={item.status_item !== 'EXECUTADO'}
                                    onFileSelect={(file) => responderItem(item, file)}
                                 />
                              </div>
                           </div>

                           {item.obs_gerente && (
                              <div className="alert alert-success mt-3 mb-0 small text-break">
                                 <strong>{item.data_execucao}</strong> {' - '}
                                 <strong>Usuário:</strong> {item.nome} {' - '}
                                 <strong>Solução:</strong> {item.obs_gerente}
                              </div>
                           )}

                           {item.status_item !== 'EXECUTADO' && (
                              <button className="btn btn-primary w-100 fw-bold shadow-sm mt-3"
                                 style={{ backgroundColor: '#0056b3' }}
                                 onClick={() => responderItem(item)}>
                                 <i className="fa fa-edit me-2"></i>RESPONDER
                              </button>
                           )}
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>

         {/* MODAL ZOOM */}
         {zoomImg && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
               onClick={() => setZoomImg(null)}>
               <img src={zoomImg} style={{ maxWidth: '98%', maxHeight: '98%', borderRadius: '4px' }} alt="Zoom" />
            </div>
         )}

         {/* MODAL LOADING */}
         {loading && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
               <div className="spinner-border text-primary"></div>
            </div>
         )}
         <Footer />
      </div>
   );
};

export default VistoriaResposta;